import { SectionHeading } from "./SectionHeading";

export function SponsorSection() {
  return (
    <section
      className="content-section section-tinted"
      id="sponsors"
      aria-labelledby="sponsors-title"
    >
      <div className="content-width section-layout">
        <SectionHeading
          index="SPONSORS"
          title="スポンサー募集"
          id="sponsors-title"
        />
        <div className="section-body">
          <p className="section-lead">
            若い才能の、
            <br />
            次の挑戦を支える。
          </p>
          <p>
            AIYSSでは、高い技術力と意欲を持つ学生が、年齢や経済的な事情に左右されず挑戦を続けられるよう、企業・団体の皆様から次のようなご支援を募集しています。
          </p>
          <div className="sponsor-request-list">
            <div className="sponsor-request">
              <h3>1　技術力の高い企業との連携</h3>
              <p>
                専門性を持つエンジニアによる、学生向けのオンライン講義にご協力いただける企業を募集しています。学生が早い段階から、実務で活用されている技術や知識を学べる機会をつくりたいと考えています。
              </p>
              <p>
                また、企業訪問やインターンシップ、実際のプロジェクトへの参加など、学生が技術を現場で生かせる機会を提供していただける企業も募集しています。
              </p>
            </div>
            <div className="sponsor-request">
              <h3>2　研究開発費の支援</h3>
              <p>
                学生による開発や学術研究には、さまざまな費用が必要です。生成AIサービスの利用料、クラウドGPUの利用料、ロボットをはじめとするハードウェアの購入費など、技術や意欲がありながら、資金不足によって研究開発を進められない学生がいます。
              </p>
              <p>
                若い技術者や研究者が挑戦を諦めず、アイデアを形にするための資金支援をお願いいたします。
              </p>
            </div>
            <div className="sponsor-request">
              <h3>3　交通費・宿泊費とイベント開催の支援</h3>
              <p>
                高い技術力を持つ学生は全国各地に点在しています。学生同士が実際に集まり、交流や共同開発に取り組むためには、交通費や宿泊費が大きな負担になります。
              </p>
              <p>
                参加する学生の交通費・宿泊費へのご支援に加え、交流会やオンサイトコンテスト、開発イベントなどを開催・協賛していただける企業を募集しています。
              </p>
            </div>
          </div>
          <p className="sponsor-closing">
            AIYSSの活動やスポンサー支援に関心をお持ちいただけましたら、ぜひお問い合わせください。
          </p>
          <a
            className="text-link sponsor-link sponsor-contact-cta"
            href="/contact/?type=sponsor#contact"
            aria-label="スポンサー協賛についてお問い合わせフォームを開く"
          >
            スポンサー協賛についてお問い合わせ <span aria-hidden="true">→</span>
          </a>
        </div>
      </div>
    </section>
  );
}
